import React from 'react';
import './badge.css';

const VARIANT_ALIASES = {
    error: 'danger',
    critical: 'danger',
    primary: 'accent',
    white: 'neutral',
    default: 'neutral',
    secondary: 'neutral',
    gray: 'neutral',
    muted: 'neutral',
};

/**
 * Badge: a small pill for counts, tags and states.
 * variant: neutral | accent | success | warning | danger | info | brand
 * (aliases: primary -> accent, error -> danger, white -> neutral)
 * dot: prefix a coloured dot. size: sm | md.
 */
export default function Badge({ variant = 'neutral', size = 'md', dot = false, className = '', children, ...rest }) {
    const v = VARIANT_ALIASES[variant] || variant;
    return (
        <span className={`yelo-badge yelo-badge--${v} yelo-badge--${size} ${dot ? 'yelo-badge--dot' : ''} ${className}`} {...rest}>
            {children}
        </span>
    );
}
